/**
 * Copyright © Magento, Inc. All rights reserved.
 * See COPYING.txt for license details.
 */

define('Magento_Theme/js/model/breadcrumb-list',[], function () {
    'use strict';

    return [];
});

